import Image from "next/image";
import { useHomeData } from "../../hooks/useHomeData";
import { Container } from "@/components/ui/container";
import { ButtonLink } from "@/components/ui/button";
import S from "./index.module.scss";
import clsx from "clsx";

const BlockSection = () => {
  const { home } = useHomeData();

  return home?.block?.map((item, idx) => (
    <Container className={S.wrapper} key={item.title}>
      <Image src={item.bg} alt={item.title || ""} width={1600} height={900} className={S.image} />
      <div
        className={clsx(S.content, {
          [S["content--black"]]: idx === 1,
        })}
      >
        <h2
          dangerouslySetInnerHTML={{ __html: item.title }}
          className={clsx(S.title, {
            [S["title--black"]]: idx === 1,
          })}
        />
        {item.button && (
          <ButtonLink className={S.styledButton} href={item.button?.link} variant={idx === 1 ? "white" : "black"}>
            {item.button?.title}
          </ButtonLink>
        )}
      </div>
    </Container>
  ));
};

export default BlockSection;
